import type { ReactNode } from "react";

import svgPaths from "./svg-x102np0vda";

type BusinessFooterSocialIconsProps = {
  labels: {
    instagram: string;
    linkedin: string;
    youtube: string;
    facebook: string;
    telegram: string;
  };
};

function IconLink({
  href,
  label,
  children,
}: {
  href: string;
  label: string;
  children: ReactNode;
}) {
  return (
    <a href={href} target="_blank" rel="noreferrer" aria-label={label}>
      {children}
    </a>
  );
}

function TeenyiconsInstagramSolid() {
  return (
    <div
      className="relative h-[24px] w-[24px] shrink-0"
      data-name="teenyicons:instagram-solid"
    >
      <svg
        className="absolute block h-full w-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
      >
        <g clipPath="url(#clip0_instagram)" id="teenyicons:instagram-solid">
          <path
            d={svgPaths.p352dc3d0}
            fill="var(--fill-0, white)"
            fillOpacity="0.4"
            id="Vector"
            stroke="var(--stroke-0, #0F0003)"
            strokeWidth="2"
          />
          <path
            clipRule="evenodd"
            d={svgPaths.p671100}
            fill="var(--fill-0, white)"
            fillOpacity="0.4"
            fillRule="evenodd"
            id="Vector_2"
          />
          <rect
            fill="var(--fill-0, #0F0003)"
            height="2.5"
            id="Rectangle 1449"
            width="2.5"
            x="17.1953"
            y="4.75"
          />
        </g>
        <defs>
          <clipPath id="clip0_instagram">
            <rect fill="white" height="24" width="24" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Linkedin() {
  return (
    <div className="relative h-[24px] w-[24px] shrink-0" data-name="linkedin 1">
      <svg
        className="absolute block h-full w-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
      >
        <g clipPath="url(#clip0_linkedin)" id="linkedin 1">
          <path
            clipRule="evenodd"
            d={svgPaths.p167f5280}
            fill="var(--fill-0, white)"
            fillOpacity="0.4"
            fillRule="evenodd"
            id="Vector"
          />
        </g>
        <defs>
          <clipPath id="clip0_linkedin">
            <rect fill="white" height="24" width="24" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function LogosYoutubeIcon() {
  return (
    <div
      className="h-[20px] relative shrink-0 w-[28.444px]"
      data-name="logos:youtube-icon"
    >
      <svg
        className="absolute block h-full w-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 28.4444 20"
      >
        <g clipPath="url(#clip0_youtube)" id="logos:youtube-icon">
          <path
            d={svgPaths.p3f48f500}
            fill="var(--fill-0, white)"
            fillOpacity="0.4"
            id="Vector"
          />
          <path
            d={svgPaths.p27bd0b80}
            fill="var(--fill-0, #0F0003)"
            id="Vector_2"
          />
        </g>
        <defs>
          <clipPath id="clip0_youtube">
            <rect fill="white" height="20" width="28.4444" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function LogosFacebook() {
  return (
    <div
      className="relative h-[24px] w-[24px] shrink-0"
      data-name="logos:facebook"
    >
      <svg
        className="absolute block h-full w-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
      >
        <g clipPath="url(#clip0_facebook)" id="logos:facebook">
          <path
            d={svgPaths.p1fdd2200}
            fill="var(--fill-0, white)"
            fillOpacity="0.4"
            id="Vector"
          />
          <path
            d={svgPaths.p23faaa00}
            fill="var(--fill-0, #0F0003)"
            id="Vector_2"
          />
        </g>
        <defs>
          <clipPath id="clip0_facebook">
            <rect fill="white" height="24" width="24" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function LogosTelegram() {
  return (
    <div
      className="relative h-[24px] w-[24px] shrink-0"
      data-name="logos:telegram"
    >
      <svg
        className="absolute block h-full w-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
      >
        <g clipPath="url(#clip0_telegram)" id="logos:telegram">
          <path
            d={svgPaths.p4c36000}
            fill="var(--fill-0, white)"
            fillOpacity="0.4"
            id="Vector"
          />
          <path
            d={svgPaths.p370b7680}
            fill="var(--fill-0, #0F0003)"
            id="Vector_2"
          />
        </g>
        <defs>
          <clipPath id="clip0_telegram">
            <rect fill="white" height="24" width="24" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default function BusinessFooterSocialIcons({
  labels,
}: BusinessFooterSocialIconsProps) {
  return (
    <div className="content-stretch flex items-center gap-[24px]">
      <IconLink
        href="https://instagram.com/waylightme"
        label={labels.instagram}
      >
        <TeenyiconsInstagramSolid />
      </IconLink>
      <IconLink
        href="https://www.linkedin.com/company/waylightme"
        label={labels.linkedin}
      >
        <Linkedin />
      </IconLink>
      <IconLink
        href="https://youtube.com/channel/UCgJWe3BMMsPWHeD8uIHZXaA"
        label={labels.youtube}
      >
        <LogosYoutubeIcon />
      </IconLink>
      <IconLink
        href="https://www.facebook.com/waylightme/"
        label={labels.facebook}
      >
        <LogosFacebook />
      </IconLink>
      <IconLink href="https://t.me/waylightme" label={labels.telegram}>
        <LogosTelegram />
      </IconLink>
    </div>
  );
}
